import React from 'react';
import { Box, Flex, Popover, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconHandFinger, IconInfoCircle, IconPlus } from '@tabler/icons-react';
import styles from './Legend.module.scss';

export const Legend: React.FC = () => {
	return (
		<Popover position="right-end">
			<Popover.Target>
				<UnstyledButton p="xs" className={styles.trigger}>
					<IconInfoCircle />
				</UnstyledButton>
			</Popover.Target>

			<Popover.Dropdown>
				<Stack gap="xs" className={styles.stack}>
					<Flex gap="xs">
						<Box bg="cream.3" className={styles.icon}>
							<IconPlus />
						</Box>
						<Text size="sm">Kliknij + aby dodać moduły</Text>
					</Flex>
					<Flex gap="xs">
						<Box bg="cream.3" className={styles.icon}>
							<IconHandFinger />
						</Box>
						<Text size="sm">Dostosuj tkaninę i kolor</Text>
					</Flex>
				</Stack>
			</Popover.Dropdown>
		</Popover>
	);
};
